import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import type { Observable } from 'rxjs';
import type { ImportProgress } from '../../../../common/interfaces/import-progress';
import type { PointsOfInterestImportData } from '../constants/points-of-interest-import-schema';
import { PointsOfInterestService } from '../services/points-of-interest.service';

export const importPointsOfInterestResolver: ResolveFn<
  (data: PointsOfInterestImportData[]) => Observable<ImportProgress>
> = () => {
  const pointsOfInterestService = inject(PointsOfInterestService);
  return (data) => pointsOfInterestService.importPointsOfInterest(data);
};
